import { mapGetters, mapActions } from 'vuex';
import accountDesktopHeader from '@/components/account/account-desktop-header/account-desktop-header.vue';
import contentHeader from '@/components/generics/content-header/content-header.vue';
import profile from '@/components/account/profile/profile.vue';
import tabs from '@/components/generics/tabs/tabs.vue';
import trades from '@/components/account/history/trades/trades.vue';
import transactions from '@/components/account/history/transactions/transactions.vue';
import { MODALS } from '@/components/app/app-modals/app-modals';

const TAB_TRADES = 'trades';
const TAB_DEPOSIT_WITHDRAWALS = 'deposit-withdrawals';

export default {
  props: {
    marketId: {},
  },
  components: {
    accountDesktopHeader,
    contentHeader,
    profile,
    tabs,
    trades,
    transactions,
  },
  data() {
    return {
      ready: false,
      activeTab: '',
      tabs: [
        { name: TAB_TRADES, title: 'Trades' },
        { name: TAB_DEPOSIT_WITHDRAWALS, title: 'Deposits/Withdrawals' },
      ],
    };
  },
  metaInfo() {
    return {
      title: 'History',
    };
  },
  computed: {
    ...mapGetters('app', ['isLayoutDesktop', 'isLayoutMobile']),
    tradesKey() {
      return `trades-${this.isLayoutMobile.toString()}`;
    },
    transactionsKey() {
      return `transactions-${this.isLayoutMobile.toString()}`;
    },
    showTradesTab() {
      return this.activeTab === TAB_TRADES;
    },
    showTransactionsTab() {
      return this.activeTab === TAB_DEPOSIT_WITHDRAWALS;
    },
    gridRowModifier() {
      return {
        row: this.isLayoutMobile,
        'row-x': !this.isLayoutMobile,
      };
    },
  },
  methods: {
    ...mapActions('overlay', {
      showOverlay: 'show',
    }),
    ...mapActions('popup', ['setCurrentPopup']),
    ...mapActions('profile', ['resetTradeHistory', 'resetTransactionHistory']),
    onExport(what) {
      this.showOverlay();
      if (what === TAB_TRADES) {
        this.setCurrentPopup(MODALS.EXPORT_TRADE_HISTORY);
      } else {
        this.setCurrentPopup(MODALS.EXPORT_TRANSACTION_HISTORY);
      }
    },
    tabChange(name) {
      if (name === TAB_DEPOSIT_WITHDRAWALS) {
        this.resetTransactionHistory();
      } else if (name === TAB_TRADES) {
        this.resetTradeHistory();
      }

      setTimeout(() => {
        if (this.activeTab && this.$route && this.$route.path) {
          this.$gtm.trackEvent({
            event: 'pageviewTrackerEvent',
            virtualPage: `${this.$route.path}/${name}`,
            virtualPageTitle: `${this.$route.name} - ${name}`,
          });
        }

        this.activeTab = name;
        if (name && this.$router.currentRoute.query.tabId !== name) {
          this.$router.push({
            name: 'account-history',
            query: {
              ...this.$route.query,
              tabId: this.activeTab,
            },
          });
        }
      }, 0);
    },
  },
  watch: {
    '$route.query' (value) {
      if (value.tabId && value.tabId !== this.activeTab) {
        this.resetTransactionHistory();
        this.resetTradeHistory();
        this.activeTab = value.tabId;
      }
    },
  },
  created() {
    if (this.$route.query.tabId) {
      this.activeTab = this.$route.query.tabId;
    } else {
      this.activeTab = 'trades';
      this.$router.push({ name: 'account-history', query: { tabId: 'trades' } });
    }
    this.ready = true;
  },
  beforeDestroy() {
    this.resetTransactionHistory();
    this.resetTradeHistory();
  }
};



// WEBPACK FOOTER //
// ./src/components/account/history/history.js